import { useEffect, useState } from "react";
import ProductCarousel from "../../components/ProductCarousel/ProductCarousel";
import { ProductWithoutIndex } from "../../interfaces/interfaces";
import { log } from "../../commonfunctions/logger";
import { getSubdomain } from "../../context/ContextApp";
import { useNavigate } from "react-router-dom";
import { subdomainTypes } from "../../context/availableSubdomains";
import { updateCurrentOrder } from "../../redux/actions/orders";
import { useDispatch } from "react-redux";
import getProducts from "./fetch/getProducts";
import getSliders, { SliderDetailResponse } from "./fetch/getSliders";
import getCurrentOrder from "./fetch/getCurrentOrder";

const HomePage = () => {
  const [sliderResponse, setSliderResponse] = useState<SliderDetailResponse | null>(null);
  const [products, setProducts] = useState<ProductWithoutIndex[]>([]);
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);
  const [clearanceProducts, setClearanceProducts] = useState<ProductWithoutIndex[]>([]);
  const [loadingClearanceProducts, setLoadingClearanceProducts] = useState<boolean>(false);
  const [loadingSliders, setLoadingSliders] = useState<boolean>(false);
  const appBranch = getSubdomain();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSliders = async () => {
      setLoadingSliders(true);
      try {
        const data = await getSliders(appBranch);
        if (data) setSliderResponse(data);
      } catch (error) {
        log(error, "Failed to load sliders");
      } finally {
        setLoadingSliders(false);
      }
    };

    const fetchProducts = async () => {
      setLoadingProducts(true);
      const result = await getProducts(appBranch);
      if (result.products) setProducts(result.products);
      setLoadingProducts(false);
    };

    const fetchClearanceProducts = async () => {
      setLoadingClearanceProducts(true);
      const result = await getProducts(appBranch, "&sales_status=clearance");
      if (result.products) setClearanceProducts(result.products);
      setLoadingClearanceProducts(false);
    };

    const fetchCurrentOrder = async () => {
      const result = await getCurrentOrder();
      if (result.order) dispatch(updateCurrentOrder(result.order));
    };

    if (appBranch === subdomainTypes.CA) {
      navigate("/store/cart");
    }

    fetchCurrentOrder();
    fetchSliders();
    fetchProducts();
    fetchClearanceProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSliderSkeletons = () =>
    Array.from({ length: 3 }).map((_, index) => (
      <div key={`slider-skeleton-${index}`} className="slider-skeleton">
        <div className="slider-skeleton-image" />
      </div>
    ));

  return (
    <div className="home-page">
      <ProductCarousel title="Just Landed" products={products} loading={loadingProducts} />
      <ProductCarousel
        title="Clearance"
        products={clearanceProducts}
        loading={loadingClearanceProducts}
        viewAllUrl="/products?sales_status=clearance"
      />
      <h2>What&apos;s New</h2>
      <section className="slider_section">
        {loadingSliders
          ? renderSliderSkeletons()
          : sliderResponse?.slider &&
            sliderResponse.slider.map((slider, index) => (
              <a
                href={slider.link}
                key={index}
                target="_blank"
                className="slider_card"
                rel="noreferrer"
              >
                <img alt="slider image" src={slider.image} className="slider-img" />
              </a>
            ))}
      </section>
    </div>
  );
};

export default HomePage;
